import React, { useEffect, useState } from 'react';
import Bounce from 'react-reveal/Bounce';
import Heading from '../Heading';
import { getPromoProducts } from '../../api/products';
import useAuth from '../../hooks/useAuth';
import useOrder from '../../hooks/useOrder';
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { BsCart2 } from 'react-icons/bs';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';

const PromoProducts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const { handleCart } = useOrder();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const res = await getPromoProducts();
        const inStockOnly = res.data.filter((p) => p.quantity > 0);
        const shuffled = inStockOnly.sort(() => 0.5 - Math.random());
        setData(shuffled.slice(0, 8));
      } catch (err) {
        console.error('Erreur lors du chargement des produits en promotion', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPromos();
  }, []);

  const handleAddToCart = async (productId) => {
    try {
      await handleCart({ _id: productId, quantity: 1 });
      swal('✅ Ajouté', 'Produit ajouté au panier', 'success');
    } catch (err) {
      console.error('Erreur ajout panier:', err);
      swal('❌ Erreur', 'Impossible d’ajouter au panier', 'error');
    }
  };

  const renderCard = (product) => {
    const originalPrice = product.initialPrice;
    const promoPrice = (
      originalPrice * (1 - product.promoPercentage / 100)
    ).toFixed(2);

    return (
      <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition relative flex flex-col justify-between">
        {product.promoPercentage && (
          <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded-full shadow-md z-10">
            -{product.promoPercentage}%
          </span>
        )}
        <div className="w-full h-[230px] bg-gray-100 rounded overflow-hidden flex items-center justify-center mb-3">
          <img
            src={product.image}
            alt={product.name}
            className="max-h-full max-w-full object-contain"
          />
        </div>
        <h2 className="text-lg font-bold truncate">{product.name}</h2>
        <p className="text-gray-500 line-through">{originalPrice} TND</p>
        <p className="text-paragaia text-xl font-semibold">{promoPrice} TND</p>

        <div className="flex flex-col md:flex-row justify-between items-center mt-4 gap-2">
          {user && (
            <button
              className="bg-paragaia text-white px-3 py-2 rounded-md text-sm flex items-center gap-2 hover:bg-paragaiaLight w-full md:w-auto"
              onClick={() => handleAddToCart(product._id)}
            >
              <BsCart2 />
              Ajouter
            </button>
          )}
          <button
            className="border border-paragaia text-paragaia px-3 py-2 rounded-md text-sm hover:bg-paragaiaLight w-full md:w-auto"
            onClick={() => {
              localStorage.setItem('selected_product_id', product._id);
              localStorage.setItem('selected_product_promo', product.promoPercentage);
              navigate(`/products/view/${encodeURIComponent(product.name)}`);
            }}
          >
            Voir
          </button>
        </div>
      </div>
    );
  };

  if (loading) return <LoadingScreen />;
  if (!data.length) return null;

  return (
    <section className="max-w-screen-xl mx-auto px-6 py-6 pb-24">
      <Heading title="Produits en Promotion" />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 py-6">
        {data.map((product) => (
          <Bounce left key={product._id}>
            {renderCard(product)}
          </Bounce>
        ))}
      </div>
    </section>
  );
};

export default PromoProducts;
